import { X, LogOut } from 'lucide-react'
import { useAuthStore } from '../stores/authStore'
import { Navigation } from './Sidebar'
import BlockManager from './BlockManager'
import usePageBuilderStore from '../stores/pageBuilderStore'

function MobileBlockManager({ entityId, entityType, blockField }) {
  const viewMode = usePageBuilderStore((state) => state.viewMode)
  return (
    <BlockManager
      entityId={entityId}
      entityType={entityType}
      blockField={blockField}
      viewMode={viewMode}
    />
  )
}

export default function MobileSidebar({
  isOpen,
  onClose,
  isPageBuilder,
  pageId,
  entityType = 'page',
  blockField = 'page_id',
}) {
  const { user, logout } = useAuthStore()

  if (!isOpen) return null

  return (
    <div className="fixed inset-0 z-50 lg:hidden">
      <div
        className="fixed inset-0 bg-gray-600 bg-opacity-75"
        onClick={onClose}
      />
      <div className="fixed inset-y-0 left-0 flex w-64 flex-col bg-white">
        <div className="flex h-16 items-center justify-between px-4">
          <h1 className="text-xl font-bold text-gray-900">Ginger CMS</h1>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600"
          >
            <X className="h-6 w-6" />
          </button>
        </div>

        {isPageBuilder ? (
          <MobileBlockManager
            entityId={pageId}
            entityType={entityType}
            blockField={blockField}
          />
        ) : (
          <Navigation />
        )}

        <div className="border-t border-gray-200 p-4">
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <div className="h-8 w-8 rounded-full bg-primary-500 flex items-center justify-center">
                <span className="text-sm font-medium text-white">
                  {user?.name?.charAt(0)?.toUpperCase()}
                </span>
              </div>
            </div>
            <div className="ml-3">
              <p className="text-sm font-medium text-gray-700">{user?.name}</p>
              <p className="text-xs text-gray-500">{user?.email}</p>
            </div>
          </div>
          <button
            onClick={logout}
            className="mt-3 flex w-full items-center px-2 py-2 text-sm text-gray-600 hover:bg-gray-50 hover:text-gray-900 rounded-md"
          >
            <LogOut className="mr-3 h-4 w-4" />
            Sign out
          </button>
        </div>
      </div>
    </div>
  )
}
